(ns ui.page-components.filter-bar.event
  (:require
   [common.schema.registry :as registry]
   [common.util :as cu]
   [frontend.state.current-session :as session]
   [re-frame.core :as rf]
   [ui.components.filter.util :as filter-util]
   [ui.page-components.filter-bar.sub :as sub]))

(rf/reg-event-fx
 ::init
 (fn [{db :db} [_ component-id all-filters init-filters]]
   {:db (-> db
            (assoc-in [::sub/all-filters component-id] all-filters)
            (assoc-in [::sub/filters component-id] init-filters))}))

(rf/reg-event-fx
 ::add-filter
 (fn [{db :db} [_ component-id default-filter]]
   {:db (-> db
            (update-in [::sub/filters component-id]
                       (fn [filters]
                         (vec (concat filters [default-filter]))))
            (assoc-in [::sub/newly-added-filter] (count (get-in db [::sub/filters component-id]))))}))

(rf/reg-event-fx
 ::save-filter
 (fn [{db :db} [_ component-id filter]]
   {:db (-> db
            (update-in [::sub/filters component-id]
                       (fn [filters]
                         (->> filters
                              (mapv (fn [f]
                                      (let [this? (= (:filter/key-path f) (:filter/key-path filter))]
                                        (if (not this?)
                                          f
                                          (merge f
                                                 (select-keys filter [:filter/operator :filter/value]))))))))))}))

(rf/reg-event-fx
 ::change-filter-field
 (fn [{db :db} [_ component-id filter-index field-path]]
   (let [all-filters (get-in db [::sub/all-filters component-id])
         field-schema (registry/get-field-schema @session/tenant-schema (last field-path))
         filter-default (->> all-filters
                             (cu/filter-by :filter/key-path field-path)
                             (first))]
     {:db (-> db
              (update-in [::sub/filters component-id]
                         (fn [filters]
                           (assoc-in filters [filter-index] filter-default))))})))

(rf/reg-event-fx
 ::change-filter-operator
 (fn [{db :db} [_ component-id filter-index new-operator]]
   {:db (-> db
            (assoc-in [::sub/filters component-id filter-index :filter/operator] new-operator))}))

(rf/reg-event-fx
 ::change-filter-value
 (fn [{db :db} [_ component-id filter-index new-value]]
   {:db (-> db
            (assoc-in [::sub/filters component-id filter-index :filter/value] new-value))}))

(rf/reg-event-fx
 ::delete-filter
 (fn [{db :db} [_ component-id idx]]
   {:db (-> db
            (update-in [::sub/filters component-id]
                       (fn [filters]
                         (cu/vec-remove idx filters))))}))
